<template>
  <div>
    <!-- Filter Start -->
    <div class="innerBox filter">
      <div class="d-flex flex-row justify-content-between">
        <div><h2 class="page-title">Driver List</h2></div>
        <div class="d-flex flex-row justify-content-end">
          <template v-if="user.type == 'ADMIN_MAINDEALER'">
            <div class="mr-3">
              <Multiselect
                :options="regions"
                placeholder="All Region"
                v-model="filter.region"
                class="tms-multiselect"
                style="font-family: proxima-nova, sans-serif"
              />
            </div>
            <div class="mr-3">
              <Multiselect
                :options="ekspedisi.map((x) => x.id)"
                :custom-label="(opt) => ekspedisi.find((x) => x.id == opt).kode"
                placeholder="All Ekspedisi"
                v-model="filter.ekspedisi"
                class="tms-multiselect"
                style="font-family: proxima-nova, sans-serif"
              />
            </div>
            <div class="mr-3">
              <button
                class="btn"
                type="button"
                style="
                  background-color: #f36f21;
                  color: white;
                  margin: 0;
                  width: 100%;
                  font-weight: bold;
                  font-family: proxima-nova, sans-serif;
                "
                @click="modal.upload = true"
              >
                Upload File
              </button>
            </div>
            <div class="mr-3">
              <router-link
                to="/dashboard/create-driver"
                style="color: white; text-decoration: none"
              >
                <button
                  class="btn"
                  type="button"
                  style="
                    background-color: #f36f21;
                    color: white;
                    margin: 0;
                    width: 100%;
                    font-weight: bold;
                    font-family: proxima-nova, sans-serif;
                  "
                >
                  Create Driver
                </button>
              </router-link>
            </div>
          </template>
          <a href="" class="btn" style="    margin-right: -1rem !important;
    padding: 0;">
            <img src="@/assets/img/notification.svg" alt="" style="display: none;">
          </a>
        </div>
      </div>
    </div>
    <!-- Filter End -->

    <!-- Chart Start -->
    <div class="row">
      <div class="col-lg-12 col-md-6">
        <div class="innerBox mt-4">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text bg-white">
                <i class="fas fa-search"></i>
              </span>
            </div>
            <input
              class="form-control filterInput col-lg-2"
              type="search"
              placeholder="Search by Name"
              aria-label="Search"
              v-model="filter.name"
              style="border-left: 0;font-family: proxima-nova, sans-serif"
              @click="vue_universal_table.update++"
            />
          </div>
          <vue-universal-table
            class="mt-3"
            api_url="/api/driver/list"
            :filter="filter"
            :fields="vue_universal_table.fields"
            :update="vue_universal_table.update"
            :buttons="vue_universal_table.buttons"
            :table_striped="false"
            :indexing="true"
            sort_order="DESC"
            sort_by="id"
            @onSeeDetails="onClick"
          ></vue-universal-table>
        </div>
      </div>
    </div>
    <!-- Chart End -->

    <!-- Modal Start -->
    <DriverUpload
      v-if="modal.upload"
      @closeModal="modal.upload = false"
      @onFinish="vue_universal_table.update++"
    />
    <!-- Modal End -->
  </div>
</template>

<script>
import debounce from "debounce";
import Multiselect from "vue-multiselect";
import DriverUpload from "./children/DriverUpload.vue";

export default {
  metaInfo: {
    title: "Driver List",
  },
  data() {
    let user = this.$store.getters.currentUser;

    return {
      user,
      modal: {
        upload: false,
      },
      apiData: [],
      regions: this.$store.getters.getRegion,
      ekspedisi: this.$store.getters.getEkspedisi,
      selectedRegion: "",
      ekspedisis: [],
      options: {
        region: this.$store.getters.getRegion,
      },
      selectedEkspedisi: "",
      tableWidth: "100%",
      tableHeight: "100%",
      rows: [],
      filter: {
        search: null,
        region: null,
        ekspedisi: null,
      },
      vue_universal_table: {
        fields: [
          { title: "Nama", variable: "name", disable_sort: true },
          {
            title: "Ekspedisi",
            variable: "kode_ekspedisi",
            disable_sort: true,
          },
          {
            title: "User Login",
            variable: "kode_ekspedisi",
            disable_sort: true,
          },
          { title: "No.HP", variable: "phone", disable_sort: true },
          { title: "Status", variable: "status", disable_sort: true },
        ],
        buttons: [{ title: "seeDetails", class: "btn btn-secondary" }],
        update: 0,
      },
    };
  },
  components: {
    Multiselect,
    DriverUpload,
  },
  mounted() {},
  watch: {
    filter: {
      deep: true,
      handler: function () {
        this.updateDebounceData();
      },
    },
    "selected.date"() {
      let split = this.selected.date.split(" to ");
      this.filter.start = split[0];
      this.filter.end = split.length > 1 ? split[1] : split[0];
      this.vue_universal_table.update++;
      this.updateDebounceData();
    },
    "selected.dateButtonsIndex"() {
      // this.filter.filter = this.selected.dateButtonsIndex != -1 ? this.options.dateButtons[this.selected.dateButtonsIndex].filter : 'CUSTOM'
    },
  },
  methods: {
    onClick(driver) {
      this.$store.state.driverData = driver;
      this.$router.push({ path: "/dashboard/driver-list/detail" });
    },
    updateDebounceData: debounce(function () {
      if (this.filter.region === 'All' || this.filter.ekspedisi === 999) {
        this.filter = {...this.filter, region: null, ekspedisi: null};
      }
      this.vue_universal_table.update++;
    }, 1000),
  },
};
</script>

<style scoped>
.innerBox {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0px 3px 10px #0000000f;
  padding: 20px;
}

.chart {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0px 3px 10px #0000000f;
  padding: 20px;
  align-items: center;
}

.elegant--sub-title {
  font-size: 18px;
  font-weight: 500;
  color: #9f9f9f;
}

.stats--icon {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.table td,
.table th {
  text-align: center;
}

.news-image-1 img {
  max-width: 100%; /* To make the image smaller and responsive */
}

.news-title-1 {
  text-align: left; /* To position the news-title on the top right */
}

.news-content-1 {
  text-align: left; /* To position the news-content on the bottom right */
}

.align-middle {
  display: flex;
  align-items: center;
}

.page-title {
  font-size: 27px;
  font-weight: bold;
  margin: 0;
}
</style>
